import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ProfileSettingsForm from './ProfileSettingsForm';
import { updateCurrentUser } from '../../services/api';
import { updateUserDetails } from '../session/session-actions';
import { DEFAULT_SETTINGS_ITEM } from './settingsCategories';
import './settings.css';

const Settings = ({
  dispatch,
  userDetails,
  initialActiveItem = DEFAULT_SETTINGS_ITEM,
}) => {
  const [activeItem, setActiveItem] = useState(initialActiveItem);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    setActiveItem(initialActiveItem);
  }, [initialActiveItem]);

  useEffect(() => {
    setError(null);
    setSuccess(null);
  }, [activeItem]);

  const handleProfileSubmit = async (payload) => {
    if (!userDetails?.token) {
      setError('You must be logged in to update your profile.');
      return;
    }

    setStatus('saving');
    setError(null);
    setSuccess(null);

    try {
      const updatedUser = await updateCurrentUser(userDetails.token, payload);
      dispatch(updateUserDetails(updatedUser));

      if (typeof window !== 'undefined' && window.localStorage) {
        const stored = window.localStorage.getItem('bodapro-user');
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            window.localStorage.setItem(
              'bodapro-user',
              JSON.stringify({
                ...parsed,
                ...updatedUser,
              }),
            );
          } catch (storageError) {
            console.warn('Failed to update stored user details', storageError);
          }
        }
      }

      setSuccess('Profile updated successfully.');
    } catch (apiError) {
      let message = 'Unable to update profile. Please try again.';

      if (apiError?.response?.data) {
        const data = apiError.response.data;

        if (typeof data === 'string') {
          message = data;
        } else if (Array.isArray(data)) {
          message = data.join(' ');
        } else if (data.detail) {
          message = data.detail;
        } else {
          const aggregated = Object.values(data)
            .reduce((acc, value) => {
              if (Array.isArray(value)) {
                return acc.concat(value);
              }
              if (typeof value === 'string') {
                acc.push(value);
              }
              return acc;
            }, [])
            .filter(Boolean)
            .join(' ');

          if (aggregated) {
            message = aggregated;
          }
        }
      } else if (apiError?.message) {
        message = apiError.message;
      }

      setError(message);
    } finally {
      setStatus('idle');
    }
  };

  const content = (
    <section className="settings-module__content settings-module__content--solo">
      {activeItem === 'profile' && (
        <ProfileSettingsForm
          initialValues={userDetails}
          status={status}
          error={error}
          success={success}
          onSubmit={handleProfileSubmit}
        />
      )}
    </section>
  );

  return (
    <div className="settings-module-content-only">
      {content}
            </div>
        );
};

Settings.icon = 'cog';
Settings.label = 'Settings';

const mapStateToProps = (state) => ({
  userDetails: state.session.userDetails,
});

export default connect(mapStateToProps)(Settings);